import { useCallback, useEffect, useRef, useState } from 'react';

import moment from 'moment';
import { useSelector } from 'react-redux';

import { getHistoryChatByChildId } from 'api/endpoints/chat';
import Message from 'pages/Chat/_components/Message';
import { convertToQueryString, groupMessageDate, handleError, scrollToBottomByRef } from 'utils/helper';

const ScreenChat = () => {
  const { me } = useSelector((state) => state.auth);
  const { childrenDetail } = useSelector((state) => state.children);

  const refChat = useRef(null);
  const refChatContent = useRef(null);
  const isLoading = useRef(false);

  const [heightChat, setHeightChat] = useState(0);
  const [isScrollToBottomScreenChat, setIsScrollToBottomScreenChat] = useState(false);
  const [currentHeightChat, setCurrentHeightChat] = useState(0);
  const [messagesHistory, setMessagesHistory] = useState({});
  const [paginationChatHistory, setPaginationChatHistory] = useState({
    page: 1,
    page_size: 50,
    total: 0,
  });

  // GET CHAT HISTORY
  const getChatHistory = useCallback(async () => {
    if (!me || !childrenDetail?.id || isLoading.current) return;

    try {
      isLoading.current = true;
      const queryString = convertToQueryString({ page: paginationChatHistory.page, page_size: paginationChatHistory.page_size });
      const response = await getHistoryChatByChildId(childrenDetail?.id, queryString);
      const messagesGrouped = await groupMessageDate(response.data, messagesHistory);

      setMessagesHistory(messagesGrouped);
      setPaginationChatHistory({ ...paginationChatHistory, total: response.total });
    } catch (error) {
      handleError(error);
    } finally {
      isLoading.current = false;
    }
  }, [me, childrenDetail?.id, paginationChatHistory.page]);

  useEffect(() => {
    getChatHistory();
  }, [getChatHistory]);

  // CALCULATE HEIGHT CHAT
  useEffect(() => {
    if (refChat.current) {
      const heightChatWrapper = refChat.current;
      const heightChatWrapperStyle = window.getComputedStyle(heightChatWrapper);

      const heightChat =
        heightChatWrapper.clientHeight - parseFloat(heightChatWrapperStyle.paddingTop) - parseFloat(heightChatWrapperStyle.paddingBottom);

      setHeightChat(heightChat);
    }
  }, [refChat.current?.clientHeight]);

  // SCROLL TO BOTTOM WHEN NEW MESSAGE
  const handleScrollToBottom = () => {
    if (!isScrollToBottomScreenChat && Object.keys(messagesHistory).length > 0) {
      scrollToBottomByRef(refChatContent);
      setIsScrollToBottomScreenChat(true);
      setCurrentHeightChat(refChatContent.current?.scrollHeight);
      return;
    }
    if (
      Math.ceil(refChatContent.current?.scrollTop + refChatContent.current?.clientHeight) + 5 >= currentHeightChat &&
      Object.keys(messagesHistory).length > 0
    ) {
      scrollToBottomByRef(refChatContent);
      setIsScrollToBottomScreenChat(true);
      setCurrentHeightChat(refChatContent.current?.scrollHeight);
      return;
    }

    refChatContent.current.scrollTop = refChatContent.current?.scrollHeight - currentHeightChat;
    return;
  };
  useEffect(() => {
    handleScrollToBottom();
  }, [messagesHistory]);

  // CHECK SCROLL IN END
  const checkScrollInEnd = () => {
    if (refChatContent.current) {
      if (refChatContent.current.scrollTop <= 0) {
        setPaginationChatHistory((prev) => ({
          ...prev,
          ...(prev.page + 1 <= Math.ceil(prev.total / prev.page_size) ? { page: prev.page + 1 } : {}),
        }));
      }
    }
  };

  // ADD EVENT LISTENER SCROLL
  useEffect(() => {
    if (refChatContent.current) {
      refChatContent.current.addEventListener('scroll', checkScrollInEnd);
    }
    return () => {
      if (refChatContent.current) {
        refChatContent.current.removeEventListener('scroll', checkScrollInEnd);
      }
    };
  }, [refChatContent.current]);

  return (
    <div className="overflow-y-hidden h-full">
      <div ref={refChat} className="relative w-full h-full">
        <div ref={refChatContent} className="flex flex-col h-full overflow-y-auto px-4" style={{ height: `${heightChat}px` }}>
          {Object.entries(messagesHistory).length > 0 ? (
            Object.entries(messagesHistory).map(([date, messages], idx) => (
              <div key={idx}>
                <div className="text-sm text-black-102 mb-2.5 flex justify-center items-center">
                  <div className="text-sm font-medium flex justify-center items-center bg-gray-651 rounded-lg w-30">
                    {moment(date).isSame(moment(), 'day') ? 'Today' : date}
                  </div>
                </div>
                {messages.map((item, idx) => (
                  <Message key={idx} item={item} is_me={item.sender_id === me?.id} />
                ))}
              </div>
            ))
          ) : (
            <div className="w-full h-full flex justify-center items-center">チャット履歴がありません</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScreenChat;
